export enum OfficeDialogMessageType {
    CloseDialog = "CLOSE_DIALOG",
    UpdateAttendees = "UPDATE_ATTENDEES",
    CommonDialogChosen = "COMMON_DIALOG_CHOSEN",
    ResourceSelected= "RESOURCE_SELECTED",
    SavedReservations = "SAVED_RESERVATIONS",
    UpdatedResourceSelected = "UPDATED_RESOURCE_SELECTED",
    DeResourceSelected= "DELETE_RESOURCE_SELECTED",
}